import * as React from 'react'
import MUIFormGroup from '@mui/material/FormGroup'

const FormGroup = (props) => <MUIFormGroup {...props} />

export default FormGroup
